import * as React from 'react';
import { useState, useEffect, useRef } from 'react';
import moment from "moment";
import { post, get, ajax } from "jquery";
import { useHistory } from 'react-router-dom';

import ContentTitle from '../../components/common/container/title';
import ElementMessage from '../../components/common/elementmessage';
import CustomModal from '../../components/common/modal/modal';
import InlineInput from '../../components/forms/inlineinput';
import DateRangeInlineInput from '../../components/forms/range/daterange';
import DatePicker, { registerLocale } from 'react-datepicker';
import { Modal } from "react-bootstrap";
import ICA0101Table from './ica0101-table';
import { isMobile } from 'react-device-detect';

import Button from '../../components/forms/button';
import "react-datepicker/dist/react-datepicker.css";

import Translate from '../../components/common/translate'
import Utils from '../../helpers/utils';
import * as CONST from '../../helpers/const';
import ja from "date-fns/locale/ja";
var jaLocale = {
  ...ja,
  options: {
    weekStartsOn: 0, firstWeekContainsDate: 1
  }
}
const getTranslateValue = Utils.getTranslateValue;

const ICA0101Master = (props) => {
  let translate = useRef(null);
  let history = useHistory();

  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");

  const [saveMessage, setSaveMessage] = useState("");
  const [saveStatus, setSaveStatus] = useState("");

  const [transactionMode, setTransactionMode] = useState(0); // 0 - add; 1 - edit
  const [pageNo, setPageNo] = useState(1);
  const [sizePerPage, setSizePerPage] = useState(10);
  const [isFetching, setLoadingState] = useState(false);

  const [cartList, setCartList] = useState([]);
  const [screenLoaded, setScreenLoaded]  = useState(false);


  const [translateSuccess, setTranslateSuccess] = useState(false);

  useEffect(() => {
    getItemsFromCart();
  }, []);

  function setStatusMessage(status, message) {
    setStatus(status);
    setMessage(message);
  }
  
  function setSaveStatusMessage(status, message) {
    setSaveStatus(status);
    setSaveMessage(message);
  }

  function clearMessage() {
    setStatus("");
    setMessage("");
  }
  
  function clearSaveMessage() {
    setSaveStatus("");
    setSaveMessage("");
  }

  function getItemsFromCart(){
    $("#loading").fadeIn();
    var sessionCart = sessionStorage.getItem('sessionCart');
    if(null != sessionCart){
      setCartList(JSON.parse(sessionCart));
    }
    setScreenLoaded(true);
    $("#loading").fadeOut();
  }

  function handleDeleteProductInCart(product) {
    let updatedCart = [...cartList];
    const existingIndex = updatedCart.findIndex(
        (item) => item.HansokuId === product.HansokuId
    );

    if (existingIndex !== -1) {
        updatedCart.splice(existingIndex, 1);
    }
        
    sessionStorage.setItem("sessionCart", JSON.stringify(updatedCart));
    setCartList(updatedCart);
  }

  function handleQuantityChange(row, newValue) {
    const updatedList = cartList.map((item) => 
    item.HansokuId === row.HansokuId ? { ...item, IraiQt: newValue} : item);

    setCartList(updatedList);
    sessionStorage.setItem("sessionCart", JSON.stringify(updatedList));
  }

  function handleRequestButtonClick() {
    const raw = sessionStorage.getItem(CONST.SessionData.FACILITYINFO);
    if (raw) {
        try {
            const saved = JSON.parse(raw);

            // BB_HANSOKU-501: Check whether a facility has actually been selected
            if (saved.FacilityName) {
                history.push(`/Cart/ConfirmFacilityInfo`);
                return;
            }
        } catch (e) { }
    }
    history.push(`/Cart/SelectFacilityInfo`);
  }

  function renderTable() {
    return (
      <div>
        <div className="row form-group">
          <div className="col-xs-4 text-left">
            <Button color="Default" divClassName="" divStyle={{ width: '100%' }} style={{ width: 100 }} label={getTranslateValue(translate.current, "views.iac0101.back")} onClick={() =>  history.push(`/Product/Search`)} />
          </div>
        </div>
        <div className="row">
          <div className="col-sm-12 col-md-12">
            {screenLoaded && (
            <ICA0101Table
              data={cartList}
              pageNo={pageNo}
              sizePerPage={sizePerPage}
              isFetching={isFetching}
              translate={translate}
              getTranslateValue={getTranslateValue.bind(this)}
              setPageNo={setPageNo.bind(this)}
              setSizePerPage={setSizePerPage.bind(this)}
              handleDelete={handleDeleteProductInCart.bind(this)}
              handleQuantityChange={handleQuantityChange}
            />
            )}
          </div>
        </div>
        <div className="row form-group justify-content-center align-items-center">
          <div className="row form-group" style={{ marginTop: 10 }}>
            <div className="col-xs-4 text-left">
              <Button color="Default" divClassName="" divStyle={{ width: '100%', marginLeft: '15px' }} style={{ width: 100 }} label={getTranslateValue(translate.current, "views.iac0101.back")} onClick={() =>  history.push(`/Product/Search`)} />
            </div>
            <div className={isMobile ? "col-xs-8 text-right" : "col-xs-4 text-center"}>
              <Button color="Success" divClassName="" divStyle={{ width: '100%' }} style={{ width: 180 , marginRight: isMobile ? "15px" : "0px"}} label={getTranslateValue(translate.current, "views.ica0101.requestbtn")} disabled={!cartList || cartList.length === 0} onClick={handleRequestButtonClick.bind(this)} />
            </div>
          {!isMobile && <div className="col-xs-4" />}
        </div>
      </div>
    </div>
    );
  }

  return (
    <Translate ref={translate} handlerLoad={setTranslateSuccess.bind(this, true)}>
      <ContentTitle active="#ICA0101" title={getTranslateValue(translate.current, "views.titleText.cart")} />
      <div className="main-content">
        <div className={isMobile ? undefined : "container-fluid"}
          style={isMobile ? undefined : { paddingLeft: '10px', paddingRight: '10px' }}>
          {
            null == message || "" == message ?
              null
              :
              <div style={{ marginLeft: '-20px', marginRight: '-20px', whiteSpace: 'pre-wrap' }}>
                <ElementMessage message={message} status={status} clearMessage={clearMessage.bind(this)} />
              </div>
          }
          {renderTable()}
        </div>
      </div>
    </Translate>
  )
}

export default ICA0101Master;


// WEBPACK FOOTER //
// ./view/ICA0101/ica0101.jsx